import { Box, Grid } from "@mui/material";
import React from "react";
//BAGITMIS;453166;15042025;
interface ByzTitleBoxProps {
  title: string;
  center?: boolean;
  sx?: React.CSSProperties;
}

const ByzTitleBox: React.FC<ByzTitleBoxProps> = ({ title, center = false ,sx }) => {
  return (
    <Grid
      container
      sx={{
        //marginX:"10px",
        // width: "calc(100% - 20px)",
        p: 2,
        borderBottom: "1px solid #E0E0E0",
        backgroundColor: "#63B4FF33",
        borderRadius: "10px",
        justifyContent: center ? "center" : "flex-start", 
        ...sx
      }}
    >
      <Box
        style={{
          fontWeight: "bold",
          fontSize: "0.9rem",
          color: "#2979C3", 
          textAlign: center ? "center" : "left",
          width: "100%",
        }}
      >
        {title}
      </Box>
    </Grid>
  );
};

export default ByzTitleBox;
